import scales from "../foundations/scales";
const icon = {
    'icon.xs': scales[0.75],
    'icon.s': scales[1],
    'icon.m': scales[1.5],
    'icon.l': scales[2]
};
export default icon;

//# sourceMappingURL=icons.js.map